// import { Router } from "express";
import { createRouter, createWebHistory } from "vue-router";
import store from "./store";

// import pages
import LoginUser from "./components/pages/LoginUser.vue";
import DashBoard from "./components/pages/DashBoard";
import homePage from "./components/pages/HomePage.vue";





const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/", component: homePage },
    { path: "/login", component: LoginUser, meta: { auth: false } },
    // { path: "/register", component: RegisterUser, meta: { auth: false } },
    { path: "/dashboard", component: DashBoard, },

    
    {
      path: "/register/clients",
     
    },
  


  ],
});
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!store.getters.isLoggedIn) {
      next({ path: '/Login' })
    } else {
      next() // go to wherever I'm going
    }
  } else {
    next() // does not require auth, make sure to always call next()!
  }
})

export default router;
